import React from 'react';

export default () => (
  <svg
  width={22}
  height={22}
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width={22} height={22} rx={11} fill="#F0F2F5" />
  <g clipPath="url(#clip0_879_2895)">
    <path
      d="M14.1305 8.33765H13.3454C13.1746 8.33765 13.0122 8.41968 12.9118 8.5603L10.2801 12.2099L9.08812 10.5558C8.98767 10.4169 8.82696 10.3332 8.65453 10.3332H7.86937C7.76055 10.3332 7.69694 10.4571 7.76055 10.5458L9.84649 13.4387C9.89577 13.5074 9.96073 13.5635 10.036 13.6021C10.1112 13.6408 10.1946 13.661 10.2792 13.661C10.3639 13.661 10.4472 13.6408 10.5225 13.6021C10.5978 13.5635 10.6627 13.5074 10.712 13.4387L14.2377 8.55026C14.303 8.46153 14.2393 8.33765 14.1305 8.33765Z"
      fill="#141414"
    />
    <path
      d="M11 3.5C6.85826 3.5 3.5 6.85826 3.5 11C3.5 15.1417 6.85826 18.5 11 18.5C15.1417 18.5 18.5 15.1417 18.5 11C18.5 6.85826 15.1417 3.5 11 3.5ZM11 17.2277C7.56138 17.2277 4.77232 14.4386 4.77232 11C4.77232 7.56138 7.56138 4.77232 11 4.77232C14.4386 4.77232 17.2277 7.56138 17.2277 11C17.2277 14.4386 14.4386 17.2277 11 17.2277Z"
      fill="#141414"
    />
  </g>
  <defs>
    <clipPath id="clip0_879_2895">
      <rect
        width={15}
        height={15}
        fill="white"
        transform="translate(3.5 3.5)"
      />
    </clipPath>
  </defs>
</svg>

);
